import type { RouteObject } from 'react-router';
import { page } from '@/app/route-utils';

/** analytics: bosh sahifa (dashboard) va analitika bo'limi (W — 5 tab, S — 2 tab). */
export const workRoutes: RouteObject[] = [
  { index: true, ...page(() => import('./pages/HomePage')) },
  { path: 'analytics', ...page(() => import('./pages/WAnalyticsPage')) },
];

export const sellerRoutes: RouteObject[] = [
  { index: true, ...page(() => import('./pages/SellerHomePage')) },
  { path: 'analytics', ...page(() => import('./pages/SAnalyticsPage')) },
];
